module.exports = __webpack_public_path__ + "img/cimentao.f1415260.png";